'use strict';

var _objectSpread = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncToGenerator = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncIterator = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var uint8ArrayFromString = require('uint8arrays/from-string');

var uint8ArrayToString = require('uint8arrays/to-string');

var log = require('debug')('ipfs-http-client:pubsub:subscribe');

var configure = require('../lib/configure');

var toUrlSearchParams = require('../lib/to-url-search-params');
/**
 * @typedef {import('../types').HTTPClientExtraOptions} HTTPClientExtraOptions
 * @typedef {import('ipfs-core-types/src/pubsub').Message} Message
 * @typedef {(err: Error, fatal: boolean, msg?: Message) => void} ErrorHandlerFn
 * @typedef {import('ipfs-core-types/src/pubsub').API<HTTPClientExtraOptions & { onError?: ErrorHandlerFn }>} PubsubAPI
 * @typedef {import('../types').Options} Options
 */

/**
 * @param {Options} options
 * @param {import('./subscription-tracker')} subsTracker
 */


module.exports = function (options, subsTracker) {
  return configure(function (api) {
    /**
     * @type {PubsubAPI["subscribe"]}
     */
    function subscribe(_x, _x2) {
      return _subscribe.apply(this, arguments);
    }

    function _subscribe() {
      _subscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(topic, handler) {
        var options,
            done,
            fail,
            result,
            ffWorkaround,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
                // eslint-disable-line require-await
                options.signal = subsTracker.subscribe(topic, handler, options.signal);
                /** @type {(value?: any) => void} */

                result = new Promise(function (resolve, reject) {
                  done = resolve;
                  fail = reject;
                }); // In Firefox, the initial call to fetch does not resolve until some data
                // is received. If this doesn't happen within 1 second assume success

                ffWorkaround = setTimeout(function () {
                  return done();
                }, 1000); // Do this async to not block Firefox

                setTimeout(function () {
                  api.post('pubsub/sub', {
                    timeout: options.timeout,
                    signal: options.signal,
                    searchParams: toUrlSearchParams(_objectSpread({
                      arg: topic
                    }, options)),
                    headers: options.headers
                  }).catch(function (err) {
                    // Initial subscribe fail, ensure we clean up
                    subsTracker.unsubscribe(topic, handler);
                    fail(err);
                  }).then(function (response) {
                    clearTimeout(ffWorkaround);

                    if (!response) {
                      // if there was no response, the subscribe failed
                      return;
                    }

                    readMessages(response, {
                      onMessage: handler,
                      onEnd: function onEnd() {
                        return subsTracker.unsubscribe(topic, handler);
                      },
                      onError: options.onError
                    });
                    done();
                  });
                }, 0);
                return _context2.abrupt("return", result);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee);
      }));
      return _subscribe.apply(this, arguments);
    }

    return subscribe;
  })(options);
};
/**
 * @param {import('ipfs-utils/src/types').ExtendedResponse} response
 * @param {object} options
 * @param {(message: Message) => void} options.onMessage
 * @param {() => void} options.onEnd
 * @param {ErrorHandlerFn} [options.onError]
 */


function readMessages(response, _ref) {
  var onMessage = _ref.onMessage,
      onEnd = _ref.onEnd,
      onError = _ref.onError;

  var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, msg;

  return _regeneratorRuntime.async(function readMessages$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          onError = onError || log;
          _context.prev = 1;
          _iteratorAbruptCompletion = false;
          _didIteratorError = false;
          _context.prev = 4;
          _iterator = _asyncIterator(response.ndjson());

        case 6:
          _context.next = 8;
          return _regeneratorRuntime.awrap(_iterator.next());

        case 8:
          if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
            _context.next = 23;
            break;
          }

          msg = _step.value;
          _context.prev = 10;

          if (msg.from) {
            _context.next = 13;
            break;
          }

          return _context.abrupt("continue", 20);

        case 13:
          onMessage({
            from: uint8ArrayToString(uint8ArrayFromString(msg.from, 'base64pad'), 'base58btc'),
            data: uint8ArrayFromString(msg.data, 'base64pad'),
            seqno: uint8ArrayFromString(msg.seqno, 'base64pad'),
            topicIDs: msg.topicIDs
          });
          _context.next = 20;
          break;

        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](10);
          _context.t0.message = "Failed to parse pubsub message: ".concat(_context.t0.message);
          onError(_context.t0, false, msg); // Not fatal

        case 20:
          _iteratorAbruptCompletion = false;
          _context.next = 6;
          break;

        case 23:
          _context.next = 29;
          break;

        case 25:
          _context.prev = 25;
          _context.t1 = _context["catch"](4);
          _didIteratorError = true;
          _iteratorError = _context.t1;

        case 29:
          _context.prev = 29;
          _context.prev = 30;

          if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
            _context.next = 34;
            break;
          }

          _context.next = 34;
          return _regeneratorRuntime.awrap(_iterator.return());

        case 34:
          _context.prev = 34;

          if (!_didIteratorError) {
            _context.next = 37;
            break;
          }

          throw _iteratorError;

        case 37:
          return _context.finish(34);

        case 38:
          return _context.finish(29);

        case 39:
          _context.next = 44;
          break;

        case 41:
          _context.prev = 41;
          _context.t2 = _context["catch"](1);

          if (!isAbortError(_context.t2)) {
            onError(_context.t2, true); // Fatal
          }

        case 44:
          _context.prev = 44;
          onEnd();
          return _context.finish(44);

        case 47:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, [[1, 41, 44, 47], [4, 25, 29, 39], [10, 16], [30,, 34, 38]], Promise);
}
/**
 * @param {Error & {type?:string}} error
 * @returns {boolean}
 */


var isAbortError = function isAbortError(error) {
  switch (error.type) {
    case 'aborted':
      return true;
    // It is `abort` in Electron instead of `aborted`

    case 'abort':
      return true;

    default:
      // FIXME: In testing with Chrome, err.type is undefined (should not be!)
      // Temporarily use the name property instead.
      return error.name === 'AbortError';
  }
};